import type { Problem } from 'cadenza/api-client/dto/problem-dto';

/**
 * checks if the parameter is a Problem
 *
 * @param error - object to check if it's a problem, usually the given parameter
 * from a .catch promise block or a try-catch block
 * @return true, if problem, else false
 */
export function isProblem (error: unknown): error is Problem {
  if (error && typeof error === 'object') {
    const problem = error as { type: unknown; key: unknown; title: unknown };
    return typeof problem.key === 'string'
      && typeof problem.type === 'string'
      && typeof problem.title === 'string';
  }
  return false;
}
